// extracted by mini-css-extract-plugin
export default {"advertDetailContactItem":"c-n_fs","advertDetailContactItem__link":"c-n_ft","advertDetailContactItem__stub":"c-n_fu"};